import { FC } from 'react';
import Image, { ImageLoader } from 'next/image';
import { Open } from '../../pages/learn';
import { urlFor } from '../../lib/sanity';
import ExternalLink from '../icons/ExternalLink.svg';
import styles from './OpenResourceCard.module.css';

const OpenResourceCard: FC<{ openResource: Open }> = ({ openResource }) => {
  const imageUrl = urlFor(openResource.imageAsset).url() ?? '';

  const myLoader: ImageLoader = ({ src }) => {
    return src;
  };

  return (
    <a href={openResource.url}>
      <div className={styles['wrapper']}>
        <div className='relative flex-shrink-0 w-24 h-24 mr-4'>
          <Image
            loader={myLoader}
            alt={openResource.title}
            src={imageUrl}
            layout='fill'
            objectFit='cover'
            unoptimized
          />
        </div>
        <div className='w-full'>
          <div className='flex justify-between'>
            <h3>{openResource.title}</h3>
            <ExternalLink className={styles['icon']} />
          </div>
          <p className='detail'>{openResource.description}</p>
        </div>
      </div>
    </a>
  );
};

export default OpenResourceCard;
